import { render, staticRenderFns } from "./taop.vue?vue&type=template&id=63353366&scoped=true&"
import script from "./taop.vue?vue&type=script&lang=js&"
export * from "./taop.vue?vue&type=script&lang=js&"
import style0 from "./taop.vue?vue&type=style&index=0&id=63353366&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63353366",
  null
  
)

export default component.exports